import React, { useState } from "react";
import { DashboardHeader } from "../../sections/admin/DashboardHeader";
import { NavigationTabs } from "../../sections/admin/NavigationTabs";
import AnalyticsDashboard from "../../sections/admin/ReportingAnalytics";
import Teachers from "../../sections/admin/Teachers";
import Schools from "../../sections/admin/Schools";
import AdminClasses from "../../sections/admin/AdminClasses";
import Roster from "../../sections/admin/Roster";
import AdminInformation from "../../sections/admin/AdminInformation";
import { LTI } from "../../sections/admin/LTI";
import SettingsModal from "../../sections/SettingsModal";

export type TabType =
  | "teachers"
  | "schools"
  | "classes"
  | "roster"
  | "reporting-analytics"
  | "lti"
  | "system-settings";

function AdminDashboard() {
  const [activeTab, setActiveTab] = useState<TabType>("teachers");
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);

  const onSaveClick = () => {
    // Logic to save the configuration
    console.info("Configuration saved!");
  };

  return (
    <div>
      <DashboardHeader
        onSaveClick={() => onSaveClick()}
        onSettingsClick={() => setIsSettingsModalOpen(true)}
      />

      <main className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <AdminInformation className="mb-6" />

        <NavigationTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === "teachers" && <Teachers />}
        {activeTab === "schools" && <Schools />}
        {activeTab === "classes" && <AdminClasses />}
        {activeTab === "roster" && <Roster />}
        {activeTab === "reporting-analytics" && <AnalyticsDashboard />}
        {activeTab === "lti" && <LTI />}
      </main>

      <SettingsModal
        isOpen={isSettingsModalOpen}
        onClose={() => setIsSettingsModalOpen(false)}
        title="Admin Settings"
        showNotifications={false}
      />
    </div>
  );
}

export default AdminDashboard;
